<template>
  <div id="add_form_transfer" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Transfer Auto Reply</h5>
          <!-- {{formParam}} -->
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Nomor WA Tujuan:</label>
                  <input
                    v-model="phoneNumberTo"
                    placeholder="Isikan dengan nomor Whatsapp yang terdaftar di Waajo"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>
                    Jumlah Auto Reply
                    <span class="badge badge-primary">{{selectedTable.length}}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="submit-section">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <center>
                    <!-- {{isSending}} -->
                    <button
                      :loading="isSending"
                      ref="dismisModal"
                      type="button"
                      data-dismiss="modal"
                      aria-label="Close"
                      class="btn btn-md btn-warning"
                    >
                      <i class="fa fa-close"></i> Cancel
                    </button>

                    <button
                      :loading="isSending"
                      @click.prevent="saveForm(0,0)"
                      class="btn btn-md btn-success"
                      type="button"
                      :style="'margin-left:10px;'"
                    >
                      <i class="fa fa-check"></i> Transfer
                    </button>
                  </center>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <center>
                    <button
                      :loading="isSending"
                      @click.prevent="saveForm(1,0)"
                      class="btn btn-lg btn-info"
                      type="button"
                    >
                      <i class="fa fa-check"></i> Transfer &amp; Exit
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { APICore, APICoreV2 } from "@/utils/servicesApi";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

export default {
  data() {
    return {
      phoneNumberTo: "",
      isSending: false,
      isLoading: false
    };
  },
  props: {
    selectedTable: {
      type: Array
    }
  },
  computed: {
    headers() {
      return {
        "X-Auth-Token": "Bearer " + this.getXAuthToken()
        // "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    },
    // ...mapGetters(["agentSession"]),
    isShowForm() {
      return this.$store.state.automation.isShowForm;
    }
  },
  methods: {
    async saveForm(isExit = 0, isDraft = 0) {
      if (this.phoneNumberTo.trim() == "") {
        this.$fire({
          title: "Error",
          text: "Nomor Whatsapp tujuan diperlukan",
          type: "error",
          timer: 2000
        }).then(r => {});
        return;
      }

      if (!this.selectedTable.length) {
        this.$fire({
          title: "Error",
          text: "Pilih Auto Reply yang akan di Transfer",
          type: "error",
          timer: 2000
        }).then(r => {});
        return;
      }

      let formParam = await {
        id: "",
        phone_number: this.phoneNumberTo
      };
      await this.$store
        .dispatch("automation/transferAutoReplyValidation", formParam)
        .then(async response => {
          // this.$fire({
          //   title: "Success",
          //   text: response["msg"],
          //   type: "success",
          //   timer: 2000
          // }).then(r => {});
          // this.isSending = false;
          // return;
          await this.$fire({
            title: "Are you sure you will continue this action?",
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: `Yes`,
            denyButtonText: `Cancel`
          }).then(async r => {
            if (r.value == true) {
              this.isSending = await true;

              // console.log("selected", this.selectedTable);

              await this.selectedTable.forEach((headerId, idx) => {
                // console.log("header_id", headerId);
                formParam = {
                  id: headerId,
                  phone_number: this.phoneNumberTo
                };
                this.$store
                  .dispatch("automation/transferAutoReply", formParam)
                  // .then(response => {
                  //   this.$fire({
                  //     title: "Success",
                  //     text: response["msg"],
                  //     type: "success",
                  //     timer: 2000
                  //   }).then(r => {});

                  //   this.isSending = false;
                  // })
                  .catch(() => {
                    this.isSending = false;
                  });
              });
              this.phoneNumberTo = await "";
              await this.$fire({
                title: "Success",
                text:
                  "Transfer sukses dilakukan. Silakan cek di akun tujuan untuk melakukan approval.",
                type: "success",
                timer: 10000
              }).then(r => {});
              if (isExit == 1) {
                var elem = await this.$refs.dismisModal;
                await elem.click();
              }
              // await this.$store
              //   .dispatch("automation/transferAutoReply", this.formParam)
              //   .then(response => {
              //     this.$fire({
              //       title: "Success",
              //       text: response["msg"],
              //       type: "success",
              //       timer: 2000
              //     }).then(r => {});
              //     if (isExit == 1) {
              //       var elem = this.$refs.dismisModal;
              //       elem.click();
              //     }
              //     this.isSending = false;
              //   })
              //   .catch(() => {
              //     this.isSending = false;
              //   });
            }
          });
        })
        .catch(() => {
          this.isSending = false;
          this.$fire({
            title: "Error",
            text:
              "Nomor Whatsapp tidak terdaftar disistem, mohon cek kembali nomor tujuan.",
            type: "error",
            timer: 2000
          }).then(r => {});
          return false;
        });
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {},
  name: "formTransfer"
};
</script>


// WEBPACK FOOTER //
// src/views/automation/smartReply/formTransfer.vue